import {Component, OnInit, EventEmitter} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {CategoryMoneyService} from '../../../_services/category-money.service';
import {UppercaseDirective} from '../../../_directives/uppercase.directive';
import {CategoryMoneyModel} from '../../../_models/category-money'

@Component({
    selector: 'app-add-category-money',
    templateUrl: './add-category-money.component.html',
    styleUrls: []
})

export class AddCategoryMoneyComponent extends DialogComponent<CategoryMoneyModel, boolean> implements OnInit {

    model: any = {};
    loading = false;
    message: string;
    focusEventEmitter = new EventEmitter<boolean>();

    constructor(
        dialogService: DialogService,
        private categoryMoneyService: CategoryMoneyService) {
        super(dialogService);
    }
 
    ngOnInit() {
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }

    add() {
        this.loading = true;
        this.message = '';
        this.categoryMoneyService.add(this.model).subscribe(data => {
            if (data.error) {
                this.message = data.message;
            } else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/category-money/add-category-money/add-category-money.component.ts